/**
 * Shared commercial analytics event names and payload shape.
 * Apps should emit these through a single helper rather than inventing local names.
 */

export const COMMERCE_EVENTS = [
  'signup',
  'free_credits_allocated',
  'generation_started',
  'generation_completed',
  'generation_failed',
  'credits_consumed',
  'credits_refunded',
  'low_credit_balance',
  'insufficient_credits',
  'credit_pack_viewed',
  'credit_purchase_started',
  'credit_purchase_completed',
  'pricing_viewed',
  'subscription_started',
  'subscription_upgrade_started',
  'subscription_upgrade_completed',
  'subscription_cancelled',
  'subscription_change_scheduled',
  'billing_interval_selected',
  'credits_expired',
  'first_generation',
  'five_credits_used',
  'free_credits_exhausted',
  'first_payment',
] as const;

export type CommerceEventName = (typeof COMMERCE_EVENTS)[number];

export interface CommerceEventProps {
  plan?: string | null;
  currency?: 'GBP' | 'EUR' | 'USD' | null;
  app?: string | null;
  feature?: string | null;
  model?: string | null;
  credit_cost?: number;
  balance?: number;
  customer_type?: 'free' | 'payg' | 'subscriber' | 'legacy' | 'enterprise';
  pricing_version?: 'v1' | 'v2' | 'v3';
  policy_id?: string | null;
  billing_interval?: 'month' | 'year' | null;
  cohort?: string | null;
  pack_id?: string;
  credits?: number;
  [key: string]: string | number | boolean | null | undefined;
}

export const COMMERCE_FUNNEL = [
  'signup',
  'first_generation',
  'five_credits_used',
  'free_credits_exhausted',
  'pricing_viewed',
  'first_payment',
  'subscription_started',
] as const;
